(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bacii-club"] && !Shopify.designMode) return;
  try {
    
  // Arrow controls for the Bacii Club video carousel. Scrolling itself is CSS
  // scroll-snap, so the carousel works with JS disabled — the arrows are extra.
  class BaciiClubCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-bacii-club-track]');
      if (!this.track) return;

      this.prev = this.querySelector('[data-bacii-club-prev]');
      this.next = this.querySelector('[data-bacii-club-next]');

      this.prev?.addEventListener('click', () => this.scrollByPage(-1));
      this.next?.addEventListener('click', () => this.scrollByPage(1));

      this.setupLazyPlayback();

      this.onScroll = () => this.updateArrows();
      this.track.addEventListener('scroll', this.onScroll, { passive: true });

      this.observer = new ResizeObserver(() => this.updateArrows());
      this.observer.observe(this.track);

      this.updateArrows();
    }

    disconnectedCallback() {
      this.track?.removeEventListener('scroll', this.onScroll);
      this.observer?.disconnect();
      this.visibility?.disconnect();
    }

    // Only the slides actually on screen load and play. Slides scrolled out of
    // the track (or the whole section scrolled off the page) are paused, so we
    // never have more than a couple of videos decoding at once.
    setupLazyPlayback() {
      const slides = this.querySelectorAll('[data-bacii-club-slide]');
      if (!slides.length) return;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!('IntersectionObserver' in window)) {
        slides.forEach((slide) => this.hydrate(slide));
        return;
      }

      this.visibility = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.hydrate(entry.target);
              this.play(entry.target);
            } else {
              this.pause(entry.target);
            }
          });
        },
        { rootMargin: '100px', threshold: 0.25 }
      );

      slides.forEach((slide) => this.visibility.observe(slide));
    }

    hydrate(slide) {
      const template = slide.querySelector('template[data-bacii-club-video]');
      if (!template) return;
      slide.appendChild(template.content.cloneNode(true));
      template.remove();
      slide.classList.add('is-loaded');
    }

    play(slide) {
      if (this.reducedMotion) return;
      slide.querySelectorAll('video').forEach((video) => {
        video.muted = true;
        video.play?.().catch(() => {});
      });
    }

    pause(slide) {
      slide.querySelectorAll('video').forEach((video) => video.pause?.());
    }

    scrollByPage(direction) {
      const slide = this.track.querySelector('li');
      const step = slide ? slide.getBoundingClientRect().width + this.gap() : this.track.clientWidth;
      this.track.scrollBy({ left: step * direction, behavior: 'smooth' });
    }

    gap() {
      return parseFloat(getComputedStyle(this.track).columnGap) || 0;
    }

    updateArrows() {
      if (!this.prev || !this.next) return;
      const max = this.track.scrollWidth - this.track.clientWidth;
      const overflowing = max > 1;
      this.prev.hidden = !overflowing || this.track.scrollLeft <= 1;
      this.next.hidden = !overflowing || this.track.scrollLeft >= max - 1;
    }
  }

  if (!customElements.get('bacii-club-carousel')) {
    customElements.define('bacii-club-carousel', BaciiClubCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
